// src/components/HowItWorks.jsx
import React from 'react';

const steps = [
  {
    num: '01',
    icon: '📅',
    title: 'Book a Session',
    desc: 'Choose a convenient time and fill in a short form to get started on your journey.',
  },
  {
    num: '02',
    icon: '🗣️',
    title: 'Initial Consultation',
    desc: 'Meet your psychologist, share your concerns in a safe, judgment-free, confidential space.',
  },
  {
    num: '03',
    icon: '🌱',
    title: 'Begin Healing',
    desc: 'Receive a personalized care plan and start your journey to a healthier, happier mind.',
  },
];

const HowItWorks = () => {
  return (
    <section className="viha-section" style={styles.section}>
      <div style={styles.container}>
        <div style={styles.header} data-aos="fade-up">
          <span className="section-badge">Our Process</span>
          <h2 style={styles.title}>Your Journey to Wellness</h2>
        </div>

        <div style={styles.stepsRow}>
          {steps.map((step, i) => (
            <React.Fragment key={step.num}>
              <div
                style={styles.stepCard}
                data-aos="fade-up"
                data-aos-delay={i * 150}
              >
                {/* Step number circle */}
                <div style={styles.numCircle}>
                  <span style={styles.num}>{step.num}</span>
                </div>

                {/* Icon */}
                <div style={styles.iconWrap}>
                  <span style={styles.icon}>{step.icon}</span>
                </div>

                <h3 style={styles.stepTitle}>{step.title}</h3>
                <p style={styles.stepDesc}>{step.desc}</p>
              </div>

              {/* Connector line (not after last item) */}
              {i < steps.length - 1 && (
                <div style={styles.connector} aria-hidden="true">
                  {/* <div style={styles.connectorLine} /> */}
                  <span style={styles.connectorArrow}>›</span>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: '#ffffff',
  },
  container: {
    maxWidth: 1100,
    margin: '0 auto',
    padding: '0 24px',
  },
  header: {
    textAlign: 'center',
    marginBottom: 60,
  },
  title: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 'clamp(24px, 3.5vw, 36px)',
    color: '#1B3F6E',
    marginTop: 8,
  },
  stepsRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: 0,
  },
  stepCard: {
    flex: '1 1 240px',
    maxWidth: 300,
    textAlign: 'center',
    padding: '0 24px',
    position: 'relative',
  },
  numCircle: {
    width: 52,
    height: 52,
    borderRadius: '50%',
    backgroundColor: '#1B3F6E',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 20px',
    boxShadow: '0 4px 16px rgba(27,63,110,0.25)',
  },
  num: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 18,
    fontWeight: 700,
    color: '#ffffff',
  },
  iconWrap: {
    width: 72,
    height: 72,
    borderRadius: '50%',
    backgroundColor: '#E8F5E2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 20px',
    border: '3px solid #5A9E4B',
  },
  icon: {
    fontSize: 32,
  },
  stepTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 20,
    fontWeight: 700,
    color: '#1B3F6E',
    marginBottom: 12,
  },
  stepDesc: {
    fontSize: 15,
    color: '#6C757D',
    lineHeight: 1.7,
    maxWidth: 240,
    margin: '0 auto',
  },
  connector: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 60,
    flexShrink: 0,
    color: '#5A9E4B',
  },
  connectorLine: {
    width: 40,
    height: 2,
    background: 'repeating-linear-gradient(90deg, #5A9E4B 0, #5A9E4B 6px, transparent 6px, transparent 12px)',
  },
  connectorArrow: {
    fontSize: 28,
    fontWeight: 700,
    color: '#5A9E4B',
    lineHeight: 0.8,
    marginTop: 4,
  },
};

export default HowItWorks;
